import React from 'react';
import Edit from '../../../containers/rest/Edit';
import Form from '../components/Form';

const OrderStatusesEdit = props => (
  <Edit {...props} resource="orderStatuses">
    <Form />
  </Edit>
);

OrderStatusesEdit.propTypes = {};

export default OrderStatusesEdit;
